var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "app-side-menu",
    { attrs: { "min-width": 18, "fixed-menu": false } },
    [
      _c(
        "aside",
        {
          staticClass: "menu",
          attrs: { slot: "side-menu" },
          slot: "side-menu",
        },
        [
          _c("p", { staticClass: "menu-label" }, [
            _c("span", { staticClass: "title is-6" }, [
              _vm._v(" Vehicle Lookup Setup "),
            ]),
          ]),
          _c("ul", { staticClass: "menu-list" }, [
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: { name: _vm.routeTypes.PricingView.name },
                      "active-class": "is-active",
                      exact: "",
                    },
                  },
                  [_c("span", [_vm._v(" Pricing ")])]
                ),
              ],
              1
            ),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: { name: _vm.routeTypes.SubscriptionView.name },
                      "active-class": "is-active",
                      exact: "",
                    },
                  },
                  [_c("span", [_vm._v(" Subscription ")])]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }